import {
  NOTIFICATIONS_API_URL,
  NOTIFICATIONS_API_URL_CUSTOM_DOMAIN,
} from 'modules/profile/notifications/api/notification-settings-api'
import { isCustomDomain } from './is-custom-domain'

export const getNotificationApiBaseUrl = (): string => {
  return isCustomDomain() ? NOTIFICATIONS_API_URL_CUSTOM_DOMAIN : NOTIFICATIONS_API_URL
}
